export default __webpack_public_path__ + "static/media/Moonoz-Sign.0231706d.jpg";